export const messages = {
    "wr-dashboard.search.input.hint": "Sök",
    "wr-dashboard.search.label.breadcrumb": "Sökresultat",
    "wr-dashboard.search.message.empty": "Inga poster matchar dina sökkriterier",
    "wr-dashboard.side-bar.selected.title:plural": "{count} valda artiklar | {count} vald artikel | {count} valda artiklar",
    "wr-dashboard.side-bar.backup-type.disk": "Disk",
    "wr-dashboard.side-bar.backup-type.file": "Fil",
    "wr-dashboard.side-bar.backup-type.notarized": "Attesterade filer och mappar",
    "wr-dashboard.side-bar.backup-type.exchange": "Program - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Program - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Program - systemtillstånd",
    "wr-dashboard.side-bar.backup-type.application": "Program",
    "wr-dashboard.backups-table.column.name": "Namn",
    "wr-dashboard.backups-table.column.size": "Storlek",
    "wr-dashboard.backups-table.column.version": "Senaste version",
    "wr-dashboard.backups-table.action.delete": "Radera",
    "wr-dashboard.backups-table.message.no-backups": "Det finns inga säkerhetskopior i molnet ännu",
    "wr-dashboard.backups-sidebar.label.size": "Storlek",
    "wr-dashboard.backups-sidebar.label.type": "Typ",
    "wr-dashboard.backups-sidebar.label.version": "Senaste version",
    "wr-dashboard.backups-sidebar.label.created": "Skapad",
    "wr-dashboard.backups-sidebar.label.machine": "Dator",
    "wr-dashboard.backups-sidebar.label.owner": "Ägare",
    "wr-dashboard.content-table.column.name": "Namn",
    "wr-dashboard.content-table.column.versions": "Versioner",
    "wr-dashboard.content-table.column.volumes": "Volymer",
    "wr-dashboard.content-table.column.path": "Sökväg",
    "wr-dashboard.content-table.column.size": "Storlek",
    "wr-dashboard.content-table.column.version": "Senaste version",
    "wr-dashboard.content-table.action.notary-verify": "Verifiera",
    "wr-dashboard.content-table.action.notary-get-crt": "Hämta certifikat",
    "wr-dashboard.content-table.action.asign": "Skicka för signatur",
    "wr-dashboard.content-table.action.versions": "Versioner",
    "wr-dashboard.content-table.action.restore": "Hämta",
    "wr-dashboard.content-table.label.size": "Storlek",
    "wr-dashboard.content-table.label.created": "Skapad",
    "wr-dashboard.content-table.label.modified": "Modifierad",
    "wr-dashboard.content-table.message.empty-folder": "Mappen är tom",
    "wr-dashboard.password-dialog-box.title.backup": "Krypterade säkerhetskopior",
    "wr-dashboard.password-dialog-box.title.archive": "Krypterat arkiv",
    "wr-dashboard.password-dialog-box.message.backup": "Ange lösenordet för att få åtkomst till säkerhetskopia {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Ange lösenordet för att få åtkomst till arkiv {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Lösenord",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Lösenordet är felaktigt",
    "wr-dashboard.form.button.open": "Öppna",
    "wr-dashboard.form.button.close": "Stäng",
    "wr-dashboard.form.button.cancel": "Avbryt",
    "wr-dashboard.form.button.continue": "Fortsätt",
    "wr-dashboard.form.button.proceed": "Fortsätt",
    "wr-dashboard.form.button.delete": "Radera",
    "wr-dashboard.form.button.done": "Klar",
    "wr-dashboard.form.button.retry": "Försök igen",
    "wr-dashboard.notary.verify.view.status.downloading": "Hämtar...",
    "wr-dashboard.notary.verify.view.status.validating": "Validerar...",
    "wr-dashboard.notary.verify.view.status.pending": "Väntande certifikat...",
    "wr-dashboard.notary.verify.view.status.fail": "Certifikat ej matchat...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Hämta certifikat",
    "wr-dashboard.notary.verify.view.file-info.name": "NAMN",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "SIGNERAT AV",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "DATUM HAR SÄKERHETSKOPIERATS",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "DATUM ATTESTERAT",
    "wr-dashboard.notary.verify.view.button.cancel": "Avbryt",
    "wr-dashboard.notary.verify.view.button.done": "Klar",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Webbläsarversionen stöds inte",
    "wr-dashboard.versions-dialog-box.title": "Versioner av {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Skicka för signatur",
    "wr-dashboard.asign-dialog-box.message": "Filversionen delas men ingen kan se filen utan länken till den. Fortsätt till ASign för att lägga till undertecknare och dela länken.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Visa filinformation",
    "wr-dashboard.page-not-found.title": "Sidan hittades inte",
    "wr-dashboard.page-not-found.message.main": "Sidan du letar efter hittades inte.",
    "wr-dashboard.page-not-found.message.description": "Länken kan vara utgången eller så kan du ha skrivit in fel adress.",
    "wr-dashboard.page-not-found.message.error": "Felkod: 404",
    "wr-dashboard.server-error.title": "Servern är inte tillgänglig",
    "wr-dashboard.server-error.message": "Servern är inte tillgänglig för tillfället. Försök igen senare.",
    "wr-dashboard.server-error.message.error": "Felkod: 500",
    "wr-dashboard.account-menu.action.sign-out": "Logga ut",
    "wr-dashboard.breadcrumb.item.machines": "Datorer",
    "wr-dashboard.breadcrumb.item.failed-backups": "Misslyckade säkerhetskopior",
    "wr-dashboard.machines-table.column.name": "Namn",
    "wr-dashboard.machines-table.column.size": "Storlek",
    "wr-dashboard.machines-table.message.no-machines": "Det finns inga datorer i molnet ännu",
    "wr-dashboard.incomplete-backups.message.status:plural": "Du har {count} misslyckade eller ofullständiga säkerhetskopior som upptar {size} lagringsutrymme | Du har {count} misslyckad eller ofullständig säkerhetskopia som upptar {size} lagringsutrymme | Du har {count} misslyckade eller ofullständiga säkerhetskopior som upptar {size} lagringsutrymme",
    "wr-dashboard.incomplete-backups.button.view": "Visa säkerhetskopior",
    "wr-dashboard.incomplete-backups.button.delete": "Radera säkerhetskopior",
    "wr-dashboard.machines-table.message.space-used:plural": "Totalt antal säkerhetskopierade körningarna {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Radera arkiv",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Radera ofullständiga arkiv",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Radera alla ofullständiga arkiv",
    "wr-dashboard.delete-archive.message": "Är du säker på att du vill ta bort det markerade arkivet permanent från alla platser? Dessa data kommer att tas bort och kan inte återställas.",
    "wr-dashboard.delete-archive.deletion-warning-message": "Eventuella ändringar som görs i denna Web Restore-konsol kanske inte återspeglas visuellt i skyddskonsolens respektive workload om workloaden inte är online och ingen agent är online för att bearbeta ändringarna",
    "wr-dashboard.delete-archive.locked-error-message": "Arkivet har låsts för att säkerställa datakonsistens. Avsluta alla åtgärder med arkivet (dvs. bläddra, återskapa, säkerhetskopiera) och försök igen.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Certifikat väntar",
    "wr-dashboard.certificate-pending-dialog-box.message": "Ök igen om några minuter.",
    "wr-dashboard.form.button.ok": "OK"
};
